import React, { useLayoutEffect, useState } from "react";
import {useHistory, useLocation} from "react-router-dom";
import { getAffiliateAcById } from "../api";
import _ from "lodash";
import "../styles/productpage.css";
import Product from "../components/Product";
import iSelfe_COVID_test from "../assets/images/iSelfe_COVID_test.png";
import SOC from "../assets/images/SOC.png";
import HIPAA_Compliant_Logo from "../assets/images/HIPAA_Compliant_Logo.png";
import AiztechLogo from "../assets/images/aiztechlabs_logo.png";
import ThirtySeconds from "../assets/images/30_seconds.png";
import NoCottonSwabs from "../assets/images/no_cotton_swabs.png";
import NoEquipement from "../assets/images/no_equipment.png";
import config from "../config";

const ProductPage = (props) => {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const affId = params.get("affId");
  const [trialDays, setTrialDays] = useState(1);
  const [affiliateAccount, setAffiliateAccount] = useState();
  const [affiliateLink, setAffiliateLink] = useState();
  const [productsAndCoupons, setProductsAndCoupons] = useState();
  const [products, setProducts] = useState([]);
  const [planDurationInterval, setPlanDurationInterval] = useState(3);
  const oneTimeProduct = _.isEmpty(products) ? {} : products.filter((product) => product.isOneTime)[0];

  const gotoSignUpURL = () => {
    if (affId) {
      return history.push(`/signup?affId=${affId}`);
    }
    history.push(`/signup`);
  };
  const gotoLoginURL = () => {
    history.push(`/login`);
  };
  useLayoutEffect(() => {
    if (affId) {
    }
    getAffiliateAcById(affId || "NA").then((res) => {
      setAffiliateAccount(res?.affiliateAccount);
      setTrialDays(res?.affiliateAccount?.trialDays || config?.defaultTrialDays);
      setAffiliateLink(res?.affiliateLink);
      setProductsAndCoupons(res?.productsAndCoupons);
      // Sort and expand product by each pricing
      const productEachPrice = [];
      for (const product of res.products) {
        product.prices.forEach((price) => {
          productEachPrice.push({ ...product, price });
        });
      }

      setProducts(productEachPrice);
    });
  }, [affId]);
  return (
    <div className="signup-product-container">
      <div className="product-header">
        <img src={AiztechLogo} alt="logo" />
      </div>
      <div className="signup-product-title">
        <div className="hero-text">
          <h1>As life goes on, viral attacks remain a daily threat to humanity.</h1>
        </div>
        <div className="hero-image">
          <img src={iSelfe_COVID_test} alt="covid-test" />
        </div>
      </div>
      <div className="signup-product-detail">
        <div>
          The iSelfie Test is a tool intended to educate users about the possible risk of having contracted COVID-19 and
          inform possible next steps in obtaining tests and/or confirming treatment eligibility. The iSelfie Test
          assesses potential risk of COVID-19 for individuals who believe they were exposed to COVID-19 by evaluating
          symptoms (if applicable) and an eye scan designed to detect changes that may be associated with infections.
          The iSelfie Test does not provide a diagnosis and is not intended to replace FDA-authorized tests or
          consultation with a healthcare provider.
          <br />
          The iSelfie Test uses your smartphone camera to scan the outer surface of the user’s eyes. It is designed to
          work on mobile devices (iOS or Android) or desktop computers with at least a 5 mega pixel camera. The eye scan
          should not be used by anyone who has recently undergone eye surgery or used eye drops or ointment in the last
          30 minutes (except for artificial tears).
          <br />
          The iSelfie Prescreen App is intended for use by individuals ages 18 and over. While all guidance and
          recommendations follow current CDC and NIH guidelines, reference to these organizations does not imply
          endorsement.
        </div>
        <div>
          <div className="benefit">Benefits</div>
          <ul className="benefit-list">
            <li className="benefit-item">
              <img src={NoCottonSwabs} alt="no-swab" />
              <div>No swab, No bio-hazards</div>
            </li>
            <li className="benefit-item">
              <img src={ThirtySeconds} alt="no-swab" />
              <div>Results under 30 seconds</div>
            </li>
            <li className="benefit-item">
              <img src={NoEquipement} alt="no-swab" />
              <div>No additional device or equipment</div>
            </li>
          </ul>
        </div>
      </div>
      {affiliateAccount && (
        <div className="referer-text">
          You are referred by {affiliateAccount?.name} and have access to exclusive products and deals.{" "}
          {products[0]?.coupon?.stripe?.metadata?.percentage &&
            `Enjoy your ${products[0]?.coupon?.stripe?.metadata?.percentage}% discount.`}
        </div>
      )}
      <div className="signup-products" style={{ marginTop: !affiliateAccount ? "120px" : "0px" }}>
        {!affiliateAccount && (
          <div className="toggle-wrapper">
            <button
              data-testid="3-months-btn"
              className={`month-button month-button-3 ${planDurationInterval !== 3 && "inactive-duration"}`}
              onClick={() => setPlanDurationInterval(3)}
            >
              3 Months
            </button>
            <button
              data-testid="6-months-btn"
              className={`month-button month-button-6 ${planDurationInterval !== 6 && "inactive-duration"}`}
              onClick={() => setPlanDurationInterval(6)}
            >
              6 Months
            </button>
          </div>
        )}
        {!affiliateAccount && (
          <div className="product-list">
            {!_.isEmpty(oneTimeProduct) && (
              <Product
                showAutoRenewal={false}
                selectedPriceId=""
                product={oneTimeProduct}
                productName={oneTimeProduct.name}
                productDescription={oneTimeProduct?.description}
                onSubscribe={gotoSignUpURL}
                subscribeCtaText={`Try Free for ${trialDays || 3} Days`}
                disableSubscribe={false}
                amount={oneTimeProduct?.price?.amount}
                features={oneTimeProduct?.features || []}
                priceId={oneTimeProduct?.price?.stripePriceId}
                intervalCount={oneTimeProduct?.price?.recurring?.interval_count}
                hideCTA
                isAutoRenewal={!oneTimeProduct?.isOneTime}
              />
            )}
            {products
              .filter((product) => product.price.recurring.interval_count === planDurationInterval)
              .sort((pre, post) => (pre?.price?.amount > post?.price?.amount ? 1 : -1))
              .map((product) => {
                return (
                  <Product
                    showAutoRenewal={false}
                    selectedPriceId=""
                    coupon={product?.coupon}
                    product={product}
                    productName={product.name}
                    productDescription={product?.description}
                    onSubscribe={gotoSignUpURL}
                    subscribeCtaText={`Try Free for ${trialDays || 3} Days`}
                    disableSubscribe={false}
                    amount={product?.price?.amount}
                    features={product?.features || []}
                    priceId={product?.price?.stripePriceId}
                    intervalCount={product.price.recurring.interval_count}
                    hideCTA
                    isAutoRenewal={!product?.isOneTime}
                  />
                );
              })}
          </div>
        )}

        {affiliateAccount?.planTemplate === "single-monthly" && affiliateAccount?.cardio && (
          <div className="product-list">
            {products
              .sort((pre, post) => (pre?.price?.amount > post?.price?.amount ? 1 : -1))
              .map((product) => {
                return (
                  <Product
                    showAutoRenewal={false}
                    selectedPriceId=""
                    coupon={product?.coupon}
                    product={product}
                    productName={product.name}
                    productDescription={product?.description}
                    onSubscribe={gotoSignUpURL}
                    subscribeCtaText={`Try Free for ${trialDays || 3} Days`}
                    disableSubscribe={false}
                    amount={product?.price?.amount}
                    features={product?.features || []}
                    priceId={product?.price?.stripePriceId}
                    intervalCount={product.price.recurring.interval_count}
                    hideCTA
                    isAutoRenewal={!product?.isOneTime}
                  />
                );
              })}
          </div>
        )}
        {affiliateAccount?.planTemplate === "single-monthly" && !affiliateAccount?.cardio && (
          <div className="product-list">
            {products
              .filter((product) => product.productType !== 'cardio')
              .sort((pre, post) => (pre?.price?.amount > post?.price?.amount ? 1 : -1))
              .map((product) => {
                return (
                  <Product
                    showAutoRenewal={false}
                    selectedPriceId=""
                    coupon={product?.coupon}
                    product={product}
                    productName={product.name}
                    productDescription={product?.description}
                    onSubscribe={gotoSignUpURL}
                    subscribeCtaText={`Try Free for ${trialDays || 3} Days`}
                    disableSubscribe={false}
                    amount={product?.price?.amount}
                    features={product?.features || []}
                    priceId={product?.price?.stripePriceId}
                    intervalCount={product.price.recurring.interval_count}
                    hideCTA
                    isAutoRenewal={!product?.isOneTime}
                  />
                );
              })}
          </div>
        )}
      </div>
      <div className="ready-to-start">Ready to start testing?</div>
      <div className="ready-to-start-cta">
        <div>
          <button data-testid="free-trial-btn" onClick={gotoSignUpURL}>{`Try Free for ${trialDays || 3} Days`}</button>
        </div>
        <div>
          <button data-testid="login-btn" onClick={gotoLoginURL}>Have an account? Login</button>
        </div>
      </div>

      <div className="contact-title">Contact</div>
      <div className="product-contact">
        If you need support or have a question, feel free to contact us. Our support team is always ready to help!{" "}
        <br />
        <a href="mailto:info@aiztechlabs.com">
          <button className="get-in-touch">Get in Touch</button>
        </a>
      </div>

      <div className="complaint">
        <img src={SOC} alt="SOC" />
        <img src={HIPAA_Compliant_Logo} alt="HIPAA_Compliant_Logo" />
      </div>
      <div className="privacy-policy">
        <a href="https://www.aiztechlabs.com/privacy" target="_blank">
          Privacy Policy
        </a>
      </div>
    </div>
  );
};

export default ProductPage;
